<template>
  <div>
    <div class="container_option_item d-flex flex-wrap justify-start align-center gap bordered rounded bg-grey_1 pa-1 mb-2">
      <div class="d-flex flex-column">
        <div class="text-h6 ml-1" style="margin-right: auto">Activité: {{ activite.nom }} - {{ activite.get_text_prix() }}</div>
        <div class="ml-1" v-if="activite.get_metadata('infos_supp')">{{ activite.get_metadata("infos_supp") }}</div>
        <div class="text-body ml-1">Places réservables: {{ places_disponibles }}</div>
      </div>
      <div class="justify-self-end" v-if="activite.is_complet()">
        <v-chip square color="dark-red">Complet</v-chip>
      </div>
      <div class="justify-self-end" v-else-if="activite.is_closed()">
        <v-chip square color="dark-red">Inscriptions closes</v-chip>
      </div>
      <div v-else class="d-flex flex-wrap align-center gap bg-white bordered pa-2 rounded justify-self-end">
        <div class="text-body-1 pt-2">Quantité</div>
        <v-btn @click="minus_quantity"><v-icon icon="mdi-minus"></v-icon> </v-btn>
        <div class="text-h6">{{ activite.quantite_souhaite }}</div>
        <v-btn @click="plus_quantity"><v-icon icon="mdi-plus"></v-icon> </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item", "commande_inscription", "all_commande_inscription"],
  data() {
    return {
      available_for_inscription: false,
      desired_quantity: 0,
      items: [],
    };
  },
  computed: {
    places_disponibles() {
      const vip = null;
      const on_add_activite_form = true;
      return this.activite.get_places_disponibles(this.commande_inscription.list_activites_amended, this.all_commande_inscription, vip, on_add_activite_form, this.commande_inscription.list_commandes_options);
    },
  },
  methods: {
    minus_quantity() {
      if (this.activite.quantite_souhaite > 0) {
        this.activite.quantite_souhaite--;
        this.$emit("updateQuantite", this.activite.quantite_souhaite);
      }
    },
    plus_quantity() {
      if (this.places_disponibles > 0) {
        this.activite.quantite_souhaite++;
        this.$emit("updateQuantite", this.activite.quantite_souhaite);
      }
    },

    build_quantity_items() {
      for (let i = 0; i < this.places_disponibles; i++) {
        this.items.push(i);
      }
    },
  },
  created() {
    this.activite = this.item;
    this.build_quantity_items();
  },
};
</script>

<style lang="scss" scoped>
</style>